import { customAlphabet } from 'nanoid'

const generateId = customAlphabet(
  '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz',
  12,
)

export const generateTariffCustomId = () => generateId()
